import {FORTRESS_MAX_DAMAGE} from "../../configs/specialBuildings";
import {SPECIAL_BUILDING_TOKENS} from "../../constants/tokens";
import {calculateOrcLoss} from "../factions/orcs/calculateOrcLoss";
import {FORTRESS_MELEE_DAMAGE_RATION} from "../../constants/combat";
import {isUnitFaction} from "../factions/isUnitFaction";
import {FACTIONS} from "../../constants/factions";

export const calcUnitReceivedMeleeDamage = (unit, pendingMeleeDamage) => {
  let totalDamage = 0;
  const damageByPlayer = {};

  pendingMeleeDamage.forEach(damageAction => {
    const receivedDamage = damageAction.damageDistribution[unit.id];
    if (receivedDamage) {
      totalDamage += receivedDamage;

      if (!damageByPlayer[damageAction.ownerId]) {
        damageByPlayer[damageAction.ownerId] = 0;
      }
      damageByPlayer[damageAction.ownerId] += receivedDamage;
    }
  })

  return {receivedDamage: totalDamage, damageByPlayer};
};

/**
 * Вычисляет эффективный урон по отряду в ближнем бою с учётом крепости.
 * Если отряд находится на крепости:
 *   - Каждые 3 единицы входящего урона наносят 1 урон размеру отряда и 1 повреждение крепости.
 *   - Остаток (<3) поглощается крепостью, пока она цела.
 *   - Если крепость уничтожена (достигнут порог 10), весь оставшийся урон идёт на отряд 1:1.
 *
 * @param {Object} unit - Объект отряда
 * @param {Array} pendingMeleeDamage - Массив pendingMeleeDamage
 * @param {Object} specialBuildings - Объект специальных строений
 * @param {Object} buildingsDamage - Объект повреждений строений
 * @param fortressesUnderConstruction
 * @returns {Object} {receivedDamage, damageByPlayer, fortressDamage}
 */
export const calcUnitMeleeDamageWithFortress = (unit, pendingMeleeDamage, specialBuildings, buildingsDamage, fortressesUnderConstruction) => {
  const {
    receivedDamage: cumulativeReceivedDamage,
    damageByPlayer
  } = calcUnitReceivedMeleeDamage(unit, pendingMeleeDamage);

  if (specialBuildings?.[unit.hexKey] !== SPECIAL_BUILDING_TOKENS.FORTRESS
    || fortressesUnderConstruction?.includes(unit.hexKey)
  ) {
    let sizeLoss = cumulativeReceivedDamage;
    if (isUnitFaction(unit, FACTIONS.ORCS)) {
      sizeLoss = calculateOrcLoss(cumulativeReceivedDamage)
    }
    return {sizeLoss, damageByPlayer, fortressDamage: 0};
  }

  const existingFortressDamage = buildingsDamage?.[unit.hexKey] || 0;
  let pendingDamage = cumulativeReceivedDamage;
  let unitReceivedDamage = 0;
  let newFortressDamage = 0;

  while (pendingDamage >= FORTRESS_MELEE_DAMAGE_RATION
    && existingFortressDamage + newFortressDamage < FORTRESS_MAX_DAMAGE
    ) {
    pendingDamage -= FORTRESS_MELEE_DAMAGE_RATION;
    unitReceivedDamage += 1;
    newFortressDamage += 1;
  }

  if (existingFortressDamage + newFortressDamage >= FORTRESS_MAX_DAMAGE) {
    unitReceivedDamage += pendingDamage;
  }

  let sizeLoss = unitReceivedDamage;
  if (isUnitFaction(unit, FACTIONS.ORCS)) {
    sizeLoss = calculateOrcLoss(unitReceivedDamage)
  }

  return {sizeLoss, damageByPlayer, fortressDamage: newFortressDamage};
};
